module.exports = __webpack_public_path__ + "static_pc/img/15.dfff483a.png";